/**
 * @generated SignedSource<<f3d68e5a72fdb60e82baebfe1b4c321d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_item$data = {
  readonly vertical: VerticalType | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBuyerMessage_item" | "CheckoutDeliveryOptions_item" | "CheckoutGifting_item" | "CheckoutMobileSummaryNewPane_item" | "CheckoutReviewStepDeliveryView_item" | "CheckoutSubmitButton_item">;
  readonly " $fragmentType": "CheckoutReviewStep_item";
};
export type CheckoutReviewStep_item$key = {
  readonly " $data"?: CheckoutReviewStep_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBuyerMessage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepDeliveryView_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPane_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutGifting_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "484940814601e2958150b6ab8c37351a";

export default node;
